module.exports = __webpack_public_path__ + "img/troppo-squisito.b3433757.jpg";